module.exports = __webpack_public_path__ + "static/media/benefits-img-2.99e2b331.png";